import { DeliveryAddressModel } from "./DeliveryAddressModel";
import { ServiceModel } from "./ServiceModel";
import { TerminalContractModel } from "./TerminalContractModel";
import { TerminalModel } from "./TerminalModel";
import { TerminalTypeModel } from "./TerminalTypeModel";
import { TidModel } from "./TidModel";
import { UserModel } from "./UserModel";

export type TerminalRequestModel = {
  terminalNeedCode: number;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  createdByUser?: UserModel | null;
  updatedBy: string;
  updatedByUser?: UserModel | null;
  serviceCode: string;
  service?: ServiceModel | null;
  deliveryAddressCode: number;
  deliveryAddress?: DeliveryAddressModel | null;
  terminalTypeCode: number;
  terminalType?: TerminalTypeModel | null;
  tidCode?: number | null;
  tid?: TidModel | null;
  terminalCode?: number | null;
  terminal?: TerminalModel | null;
  isReplacementNeed?: string | null;
  status: string;
  terminalContractId?: number | null;
  terminalContract?: TerminalContractModel | null;
  //casted
  partnerName?: string | null;
  seat?: string | null;
  fullAddress?: string | null;
  terminalTypeName?: string | null;
  createdAtDate?: string | null;
};

export type TerminalRequestTableKey = {
  label: string;
  key: string;
  align?: "inherit" | "left" | "right" | "center" | "justify" | null;
};

export const tableKeys: TerminalRequestTableKey[] = [
  { label: "Ügyfél neve", key: "partnerName" },
  { label: "Telephely neve", key: "seat" },
  { label: "Telephely címe", key: "fullAddress" },
  { label: "Terminál típusa", key: "terminalTypeName" },
  { label: "Igénylés ideje", key: "createdAtDate" },
];
